import { Component, OnDestroy, OnInit } from '@angular/core';
import { MapConstants } from 'src/app/utils/map.constant';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';
import { ConstantsModule } from '../../shared/constants/constants.module';
import { RainfallConstants } from './utils/constant/rainfall-map.constant';
import { MapService } from './utils/service/map.service';
import { RainfallService } from './utils/service/rainfall.service';

@Component({
  selector: 'app-forecast-rainfall',
  templateUrl: './forecast-rainfall.component.html',
  styleUrls: ['./forecast-rainfall.component.scss'],
})
export class ForecastRainfallComponent implements OnInit, OnDestroy {

  component: any;
  layerList: any[];
  stateName: any;
  otherOptions: {};
  sourceSelected: any;
  primary: any;
  secondary: any;
  initializeBool = true;
  stateId = 'akbm';

  constructor(
    private rainfallService: RainfallService,
    private utilService: UtilsService,
    public constants: ConstantsModule
  ) {
    this.stateName = ProjConstants.IDTOSTATENAMEMAPPING[this.stateId];
  }

  ngOnInit() {
    this.component = 'RAINFALL';
    this.sourceSelected = 'IMD (GFS)';
    // this.primary = this.constants.SOURCE_WISE[
    //   this.sourceSelected
    // ].PrimarySourceType;
    // this.secondary = this.constants.SOURCE_WISE[
    //   this.sourceSelected
    // ].SecondarySourceType;
    this.getLayersList(RainfallConstants.CommonLayers);
    this.getOtherOptions();
    this.otherOptions['reloadAllTimeLayers'] = true;
    this.utilService.setDetermisnisticOrEnsemble('deterministic');
  }

  ngOnDestroy() {}

  getLayersList(layers) {
    let layerList = [];
    layerList = layerList.concat(this.getCommonLayers(layers));
    layerList = layerList.concat(this.getHeatMapLayers());
    this.layerList = layerList;
    
  }

  getOtherOptions() {
    const otherOptions = {};
    otherOptions['legend'] = RainfallConstants.Legend;
    otherOptions['weeklyLegend'] = RainfallConstants.Legend;
    otherOptions['service'] = MapService;
    otherOptions['changeStateBoolean'] = false;
    otherOptions['reloadAllTimeLayers'] = false;
    otherOptions['addInverseMask'] = false;
    this.otherOptions = otherOptions;
    this.utilService.setOtherOptions(otherOptions);
  }

  getCommonLayers(layers) {
    const layerList: any = layers;
    for (const i in layerList) {
      if (!isNullOrUndefined(i)) {
        const layer = layerList[i];
        layer['stateName'] = this.stateName;
        if (layer.layerNameType) {
          if (layer['serviceType'] === 'VectorLayer') {
            layer['layerName'] =
              ProjConstants.STATE_TO_LAYERTYPE_NAME[
                this.stateName + '_' + layer.layerNameType
              ];
          } else {
            layer['layerName'] =
              MapConstants.GEOSERVER_WORKSPACE_NAME +
              ':' +
              ProjConstants.STATE_TO_LAYERTYPE_NAME[
                this.stateName + '_' + layer.layerNameType
              ];
          }
        }
      }
    }
    return layerList;
  }

  getHeatMapLayers() {
    let layerList = [];
    layerList = layerList.concat(this.create10HeatMapLayers());
    return layerList;
  }

  create10HeatMapLayers() {
    const tsarray: any = this.rainfallService.get24HrsTimeStamps();
    const urls: any = [];
    for (const i in tsarray) {
      if (!isNullOrUndefined(i) && i === '0') {
        const layerObj = { ...RainfallConstants.HeatMapOptions };
        layerObj['url'] =
          ProjConstants.API_URL +
          RainfallConstants.HeatMapUrl +
          'IMD_LONG_RANGE' +
          '/' +
          'IMD_LONG_RANGE' +
          '/' +
          'RAINFALL' +
          '/' +
          tsarray[i]['timeStamp'] +
          '/' +
          '24' +
          '/3hr' +
          '/null';
        layerObj['groupName'] = tsarray[i]['timeStamp'].toString();
        if (i === '0') {
          layerObj['setDefault'] = 'true';
        } else {
          layerObj['setDefault'] = 'false';
        }
        layerObj['stateName'] = this.stateName;
        layerObj['view'] = 'Admin';
        layerObj['time'] = '10';
        layerObj['layerName'] = 'Rainfall'
        layerObj['timeLineName'] = tsarray[i]['timeLineName'];
        layerObj['timeLinePos'] = tsarray[i]['timeLinePos'];
        layerObj['leftSideName'] = tsarray[i]['leftSideName'];
        urls.push(layerObj);
        // const basinLayerObj = { ...layerObj };
        // basinLayerObj['view'] = 'Basin';
        // urls.push(basinLayerObj);
      }
    }
    return urls;
  }
}
